import {
  initialState,
  Actions,
  State,
  GET_GROUP_SESSIONS,
  GET_GROUP_SESSIONS_SUCCESS,
  GET_GROUP_SESSIONS_ERROR,
} from "../../types/group/get-sessions";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_GROUP_SESSIONS:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_GROUP_SESSIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_GROUP_SESSIONS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: true,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
